import { isTeachMode } from './env';

const USER_TOKEN_KEY = 'user_token';
const TEACH_TOKEN_KEY = 'teach_token';

function getTokenKey() {
  return isTeachMode() ? TEACH_TOKEN_KEY : USER_TOKEN_KEY;
}

function isLogin() {
  return !!localStorage.getItem(getTokenKey());
}

function getToken() {
  console.log('获取token', getTokenKey());
  return localStorage.getItem(getTokenKey());
}

function setToken(token: string) {
  if (!token) {
    console.warn('🔶 Warning: Trying to set empty token');
    return;
  }

  localStorage.setItem(getTokenKey(), token);
}

function clearToken() {
  localStorage.removeItem(getTokenKey());
  clearWxConfig();
}

function clearWxConfig() {
  localStorage.removeItem('__WX_CONFIG__');
}

export { clearToken, clearWxConfig, getToken, isLogin, setToken };
